import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableCheckbox from 'components/ui_components/table/TableCheckbox';

export default function BaseTableCellSelect({ row, defaultSelected = [], readMode, handleSelectRow, isSelected}) {
  const labelId = `enhanced-table-checkbox-${row.id}`;
  const selectedByDefault = (id) => defaultSelected.indexOf(id) !== -1;

  const handleCellClick = (event) => {
    event.stopPropagation();
  };

  return (
    <TableCell className="checkbox-col" padding="checkbox" onClick={handleCellClick}>
      <TableCheckbox
        disabled={readMode || selectedByDefault(row.id)}
        onChange={event => handleSelectRow(event, row)}
        checked={!!(isSelected || readMode)}
        key={labelId}
        inputProps={{ 'aria-labelledby': labelId }}
      />
    </TableCell>
  )
}